import { AppointmentEventType, TimeRowEventType } from '../SchedulingTypes';

// Job status conditions that are derived from the appointments of the job, for
// these the block shows the status of its own appointment instead of the job
const APPOINTMENT_DRIVEN_CONDITIONS = [
    'job_created',
    'one_reserved_appointment',
    'one_scheduled_appointment',
    'running_travel_timer',
    'running_work_timer',
    'incomplete',
    'completed',
];

// Determine the status color class of an appointment or timerow event. A running
// timer colors only the block of its own resource row. As long as the job status
// follows its appointments each block shows the status of its own appointment, so
// a done appointment stays green while a later one of the same job is scheduled.
// Finished jobs and statuses set by purchases or by hand color every block alike
export const determineStatusColorClass = (event: AppointmentEventType | TimeRowEventType): string => {

    // Get the status condition of the job of the event
    const statusCondition = event.job?.status_condition ?? '';

    // A running timer on this specific resource row wins from the job status
    if (event.type === 'appointment' && event.running_timer) {
        return event.running_timer;
    }

    // Show the condition derived from the appointment status while the job status is appointment driven
    if (APPOINTMENT_DRIVEN_CONDITIONS.includes(statusCondition) && event.fallback_status_condition) {
        return event.fallback_status_condition;
    }

    return statusCondition;
};
